/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface WebNotificationsAccessData {
   /** @format uri */
   accessUrl?: string | null
}

export interface ValidationProblemDetails {
   type?: string
   title?: string
   /** @format int32 */
   status?: number
   detail?: string
   instance?: string
   errors?: Record<string, string[]>
}

export interface ProblemDetails {
   type?: string
   title?: string
   status?: number
   detail?: string
   instance?: string
   traceId?: string
}

export interface UnauthorizedResponse {
   statusCode?: number
   message?: string
}

/**
 * @example {"promotionId":1,"leaderboardId":"901f7c18-2f77-4cde-888f-79e2ed13a5b1","startDateTime":"2022-08-14T15:03:42.4696386Z","endDateTime":"2022-12-14T15:03:42.4696386Z","status":3,"banner":"Top 3 will win $10,000 cash","playerRecord":{"playerId":"1000006","rank":"23","firstName":"Anthony","lastName":"Wayne","score":1500,"tie":false},"records":[{"playerId":"1000006","rank":"1","firstName":"Jack","lastName":"Smith","score":10000,"tie":false,"hash":1317370666},{"playerId":"1000006","rank":"2","firstName":"Tom","lastName":"Nicholson","score":9000,"tie":false,"hash":1317370666},{"playerId":"1000007","rank":"3","firstName":"Amy","lastName":"Fortison","score":8000,"tie":false,"hash":1317370666},{"playerId":"1000008","rank":"4","firstName":"Jerry","lastName":"Swenson","score":7000,"tie":false,"hash":1317370666},{"playerId":"1000009","rank":"5","firstName":"Perry","lastName":"Jackson","score":6000,"tie":false,"hash":1317370666},{"playerId":"1000010","rank":"6","firstName":"Kirk","lastName":"Peterbild","score":5000,"tie":false,"hash":1317370666},{"playerId":"1000011","rank":"7","firstName":"Jenny","lastName":"Olsen","score":4000,"tie":false,"hash":1317370666},{"playerId":"1000012","rank":"8","firstName":"Paul","lastName":"Ocean","score":3000,"tie":false,"hash":1317370666},{"playerId":"1000013","rank":"9","firstName":"Michael","lastName":"Kork","score":2000,"tie":false,"hash":1317370666},{"playerId":"1000014","rank":"10","firstName":"Josh","lastName":"Small","score":1900,"tie":false,"hash":1317370666}]}
 */
export interface PlayerViewResponse {
   promotionId: number
   leaderboardId: string
   startDateTime: string
   endDateTime: string
   status: 1 | 2 | 3 | 4 | 5 | 6 | 7
   banner: string
   playerRecord: {
      playerId: string
      rank: string
      firstName: string
      lastName: string
      score: number
      tie: boolean
      hash: number
   }
   records: {
      playerId: string
      rank: string
      firstName: string
      lastName: string
      score: number
      tie: boolean
      hash: number
   }[]
}

/**
 * @example {"promotionId":1,"leaderboardId":"901f7c18-2f77-4cde-888f-79e2ed13a5b1","name":"Winter madness 2022","startDateTime":"2022-08-14T15:03:42.4696386+00:00","endDateTime":"2022-12-14T15:03:42.4696386+00:00","status":3,"banner":"Top 3 will win $10,000 cash","metricId":1,"templateId":1,"winnersColorSettings":[{"hexValue":"0000ff9F","start":0,"end":2}],"records":[{"playerId":"1000006","rank":"1","firstName":"Jack","lastName":"Smith","score":10000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000006","rank":"2","firstName":"Tom","lastName":"Nicholson","score":9000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000007","rank":"3","firstName":"Amy","lastName":"Fortison","score":8000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000008","rank":"4","firstName":"Jerry","lastName":"Swenson","score":7000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000009","rank":"5","firstName":"Perry","lastName":"Jackson","score":6000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000010","rank":"6","firstName":"Kirk","lastName":"Peterbild","score":5000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000011","rank":"7","firstName":"Jenny","lastName":"Olsen","score":4000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000012","rank":"8","firstName":"Paul","lastName":"Ocean","score":3000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000013","rank":"9","firstName":"Michael","lastName":"Kork","score":2000,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666},{"playerId":"1000014","rank":"10","firstName":"Josh","lastName":"Small","score":1900,"tie":false,"updatedOn":"2022-12-14T15:03:42.4696386+00:00","hash":1317370666}]}
 */
export interface GenericViewResponse {
   promotionId: number
   leaderboardId: string
   countdown: {
      value: number
      isEnabled: boolean
   }
   name: string
   startDateTime: string
   endDateTime: string
   propertyTimeZone: string
   status: 1 | 2 | 3 | 4 | 5 | 6 | 7
   banner: string
   playersNumber: number
   metricId: number
   templateId: number
   animationConfiguration: {
      animationTypeId: 1 | 2
      flipInterval?: number
   }
   order: 1 | 2
   sequenceId: number
   winnersColorSettings?: {
      hexValue: string
      start: number
      end: number
   }[]
   records: {
      playerId: string
      rank: string
      firstName: string
      lastName: string
      score: number
      tie: boolean
      updatedOn: string
      hash: number
   }[]
}

export interface AddUserToGroupRequest {
   userId?: string
   groupId?: string
}

export interface EveriLeaderboardParams {
   /** The ID of a promotion for which a leaderboard is requested */
   promotionId: number
   /** The ID of a player for whom to return score and rank */
   playerId: string
}

export interface MobileNativeLeaderboardParams {
   /** The ID of a promotion for which a leaderboard is requested */
   promotionId: number
   /** Specifies if the requested leaderboard should be geofenced. If not provided - false by default */
   geofencing?: boolean
}

export interface WebNotificationNegotiateParams {
   /** User identifier */
   userId?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
   /** set parameter to `true` for call `securityWorker` for this request */
   secure?: boolean
   /** request path */
   path: string
   /** content type of request body */
   type?: ContentType
   /** query params */
   query?: QueryParamsType
   /** format of response (i.e. response.json() -> format: "json") */
   format?: ResponseFormat
   /** request body */
   body?: unknown
   /** base url */
   baseUrl?: string
   /** request cancellation token */
   cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
   baseUrl?: string
   baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
   securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
   customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
   data: D
   error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
   Json = 'application/json',
   FormData = 'multipart/form-data',
   UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
   public baseUrl: string = 'https://wr2APImgmt-dev.wynntesting.com/p-p'
   private securityData: SecurityDataType | null = null
   private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
   private abortControllers = new Map<CancelToken, AbortController>()
   private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

   private baseApiParams: RequestParams = {
      credentials: 'same-origin',
      headers: {},
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
   }

   constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
      Object.assign(this, apiConfig)
   }

   public setSecurityData = (data: SecurityDataType | null) => {
      this.securityData = data
   }

   protected encodeQueryParam(key: string, value: any) {
      const encodedKey = encodeURIComponent(key)
      return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
   }

   protected addQueryParam(query: QueryParamsType, key: string) {
      return this.encodeQueryParam(key, query[key])
   }

   protected addArrayQueryParam(query: QueryParamsType, key: string) {
      const value = query[key]
      return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
   }

   protected toQueryString(rawQuery?: QueryParamsType): string {
      const query = rawQuery || {}
      const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key])
      return keys
         .map(key => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
         .join('&')
   }

   protected addQueryParams(rawQuery?: QueryParamsType): string {
      const queryString = this.toQueryString(rawQuery)
      return queryString ? `?${queryString}` : ''
   }

   private contentFormatters: Record<ContentType, (input: any) => any> = {
      [ContentType.Json]: (input: any) =>
         input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
      [ContentType.FormData]: (input: any) =>
         Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key]
            formData.append(
               key,
               property instanceof Blob
                  ? property
                  : typeof property === 'object' && property !== null
                  ? JSON.stringify(property)
                  : `${property}`
            )
            return formData
         }, new FormData()),
      [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
   }

   protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
      return {
         ...this.baseApiParams,
         ...params1,
         ...(params2 || {}),
         headers: {
            ...(this.baseApiParams.headers || {}),
            ...(params1.headers || {}),
            ...((params2 && params2.headers) || {}),
         },
      }
   }

   protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
      if (this.abortControllers.has(cancelToken)) {
         const abortController = this.abortControllers.get(cancelToken)
         if (abortController) {
            return abortController.signal
         }
         return void 0
      }

      const abortController = new AbortController()
      this.abortControllers.set(cancelToken, abortController)
      return abortController.signal
   }

   public abortRequest = (cancelToken: CancelToken) => {
      const abortController = this.abortControllers.get(cancelToken)

      if (abortController) {
         abortController.abort()
         this.abortControllers.delete(cancelToken)
      }
   }

   public request = async <T = any, E = any>({
      body,
      secure,
      path,
      type,
      query,
      format,
      baseUrl,
      cancelToken,
      ...params
   }: FullRequestParams): Promise<HttpResponse<T, E>> => {
      const secureParams =
         ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
         {}
      const requestParams = this.mergeRequestParams(params, secureParams)
      const queryString = query && this.toQueryString(query)
      const payloadFormatter = this.contentFormatters[type || ContentType.Json]
      const responseFormat = format || requestParams.format

      return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
         ...requestParams,
         headers: {
            ...(requestParams.headers || {}),
            ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
         },
         signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
         body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      }).then(async response => {
         const r = response as HttpResponse<T, E>
         r.data = null as unknown as T
         r.error = null as unknown as E

         const data = !responseFormat
            ? r
            : await response[responseFormat]()
                 .then(data => {
                    if (r.ok) {
                       r.data = data
                    } else {
                       r.error = data
                    }
                    return r
                 })
                 .catch(e => {
                    r.error = e
                    return r
                 })

         if (cancelToken) {
            this.abortControllers.delete(cancelToken)
         }

         if (!response.ok) throw data
         return data
      })
   }
}

/**
 * @title Leaderboards Score API
 * @version 1.0
 * @baseUrl https://wr2APImgmt-dev.wynntesting.com/p-p
 *
 * Provides APIs for TVs, mobile app and Everi kiosks to display leaderboards for players
 */
export class Api<SecurityDataType extends unknown> {
   http: HttpClient<SecurityDataType>

   constructor(http: HttpClient<SecurityDataType>) {
      this.http = http
   }

   leaderboards = {
      /**
       * @description Provides an endpoint for Everi that can return leaderboard's data by promotionId and playerId
       *
       * @tags Leaderboards, WynnRewards2.0, Score
       * @name EveriLeaderboard
       * @summary Everi leaderboard
       * @request GET:/leaderboards
       * @secure
       * @response `200` `PlayerViewResponse` Returns leaderboard's data along with score and rank of the requested player
       * @response `400` `ValidationProblemDetails` "Bad request" for invalid input
       * @response `401` `UnauthorizedResponse` Unauthorized
       * @response `404` `void` A leaderboard is not found for a player and a promotion
       * @response `500` `ProblemDetails` Internal server error
       */
      everiLeaderboard: (query: EveriLeaderboardParams, params: RequestParams = {}) =>
         this.http.request<PlayerViewResponse, ValidationProblemDetails | UnauthorizedResponse | void | ProblemDetails>(
            {
               path: `/leaderboards`,
               method: 'GET',
               query: query,
               secure: true,
               format: 'json',
               ...params,
            }
         ),

      /**
       * @description Provides an endpoint for TV displays that can return leaderboard's data by liveLinkId
       *
       * @tags Leaderboards, WynnRewards2.0, Score
       * @name TvLeaderboard
       * @summary TV leaderboard
       * @request GET:/leaderboards/live/{liveLinkId}
       * @secure
       * @response `200` `GenericViewResponse` Returns leaderboard's data
       * @response `400` `ValidationProblemDetails` "Bad request" for invalid input
       * @response `401` `UnauthorizedResponse` Unauthorized
       * @response `404` `void` A leaderboard is not found for this liveLinkId
       * @response `500` `ProblemDetails` Internal server error
       */
      tvLeaderboard: (liveLinkId: string, params: RequestParams = {}) =>
         this.http.request<
            GenericViewResponse,
            ValidationProblemDetails | UnauthorizedResponse | void | ProblemDetails
         >({
            path: `/leaderboards/live/${liveLinkId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
         }),

      /**
       * @description Provides a preview endpoint for TV displays that can return leaderboard's data by liveLinkId
       *
       * @tags Leaderboards, WynnRewards2.0, Score
       * @name PreviewTvLeaderboard
       * @summary Preview TV leaderboard
       * @request GET:/leaderboards/preview/{liveLinkId}
       * @secure
       * @response `200` `GenericViewResponse` Returns leaderboard's data
       * @response `400` `ValidationProblemDetails` "Bad request" for invalid input
       * @response `401` `UnauthorizedResponse` Unauthorized
       * @response `404` `void` A leaderboard is not found for this liveLinkId
       * @response `500` `ProblemDetails` Internal server error
       */
      previewTvLeaderboard: (liveLinkId: string, params: RequestParams = {}) =>
         this.http.request<
            GenericViewResponse,
            ValidationProblemDetails | UnauthorizedResponse | void | ProblemDetails
         >({
            path: `/leaderboards/preview/${liveLinkId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params,
         }),
   }
   m = {
      /**
       * @description Provides an endpoint for Wynn Mobile app that can return leaderboard's data by promotionId and playerId extracted from the access token
       *
       * @tags Leaderboards, WynnRewards2.0, Score
       * @name MobileNativeLeaderboard
       * @summary Mobile native leaderboard
       * @request GET:/m/leaderboards
       * @secure
       * @response `200` `PlayerViewResponse` Returns leaderboard's data along with score and rank of the requested player
       * @response `400` `ValidationProblemDetails` "Bad request" for invalid input
       * @response `401` `UnauthorizedResponse` Unauthorized
       * @response `404` `void` A leaderboard is not found for a player and a promotion
       * @response `500` `ProblemDetails` Internal server error
       */
      mobileNativeLeaderboard: (query: MobileNativeLeaderboardParams, params: RequestParams = {}) =>
         this.http.request<PlayerViewResponse, ValidationProblemDetails | UnauthorizedResponse | void | ProblemDetails>(
            {
               path: `/m/leaderboards`,
               method: 'GET',
               query: query,
               secure: true,
               format: 'json',
               ...params,
            }
         ),
   }
   webNotifications = {
      /**
       * @description Get websocket URL. (token expires after 1 h)
       *
       * @tags Leaderboards, WynnRewards2.0, Score
       * @name WebNotificationNegotiate
       * @summary Get client access URL
       * @request GET:/web-notifications/negotiation
       * @secure
       * @response `200` `WebNotificationsAccessData` Success
       * @response `401` `UnauthorizedResponse` Unauthorized
       * @response `500` `ProblemDetails` Internal server error
       */
      webNotificationNegotiate: (query: WebNotificationNegotiateParams, params: RequestParams = {}) =>
         this.http.request<WebNotificationsAccessData, UnauthorizedResponse | ProblemDetails>({
            path: `/web-notifications/negotiation`,
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params,
         }),

      /**
       * @description Adding user to the group (Leaderboard live link identifier)
       *
       * @tags Leaderboards, WynnRewards2.0, Score
       * @name WebNotificationGroupsNegotiate
       * @summary Add user to group
       * @request POST:/web-notifications/groups/negotiation
       * @secure
       * @response `204` `void` Success
       * @response `401` `UnauthorizedResponse` Unauthorized
       * @response `500` `ProblemDetails` Internal server error
       */
      webNotificationGroupsNegotiate: (data: AddUserToGroupRequest, params: RequestParams = {}) =>
         this.http.request<void, UnauthorizedResponse | ProblemDetails>({
            path: `/web-notifications/groups/negotiation`,
            method: 'POST',
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
         }),
   }
}
